
export const courses = r => require.ensure([], () => r(require('../components/list/courses')), 'report-bundle')
export const Reports = r => require.ensure([], () => 
                                r(require('../components/reports/index')), 'report-bundle')
export const Learners = r => require.ensure([], () => 
                                r(require('../components/reports/learners')), 'report-bundle')
export const License = r => require.ensure([], () =>
                                r(require('../components/reports/license')), 'report-bundle')
export const Departments = r => require.ensure([], () => 
                                r(require('../components/reports/departments')), 'report-bundle')
export const Courses = r => require.ensure([], () => r(require('../components/reports/courses')), 'report-bundle')

export const DepartmentTargets = r => require.ensure([], () => r(require('../components/reports/department_targets')), 'report-bundle')
export const TargetCourses = r => require.ensure([], () => r(require('../components/reports/target_courses')), 'report-bundle')

export const Emaillogs = r => require.ensure([], () => r(require('../components/logs/index')), 'report-bundle')

export const login = r => require.ensure([], () => r(require('../components/auth/login_en')),         'auth')
export const login_ar = r => require.ensure([], () => r(require('../components/auth/login_ar')),         'auth')
export const user_choice = r => require.ensure([], () => r(require('../components/auth/user_choice')),         'auth')
export const user_license = r => require.ensure([], () => r(require('../components/auth/user_license')),         'auth')
export const user_entity_license = r => require.ensure([], () => r(require('../components/auth/user_entity_license')),         'auth')
export const confirmation = r => require.ensure([], () => r(require('../components/auth/confirmation')),         'auth')



// WEBPACK FOOTER //
// ./src/app/lms/routes/components.js